import dayjs from 'dayjs'
import {v4 as uuidv4} from 'uuid'

/**
 * 날짜 구하기
 * @param ago
 * @param format
 * @returns {string}
 */
export const getDate = (ago = 0, format = 'YYYYMMDD') => {
  return dayjs().subtract(ago, 'day').format(format)
}

/**
 * 오늘기준 년월 구하기 (yyyyMM)
 * @returns {string}
 */
export const getYearMonth = () => {
  return dayjs().format('YYYYMM')
}

/**
 * 날짜 차이 구하기
 * @param before
 * @param after
 * @returns {number}
 */
export const getDiffDate = (before, after) => {
  return dayjs(after).diff(dayjs(before), 'day')
}

/**
 * 한글버전 년월 구하기 (yyyy년 mm월)
 * @returns {string}
 */
export const getKoreanYearMonth = (yearMonth) => {
  return yearMonth ? `${yearMonth.substring(0, 4)}년 ${yearMonth.substring(4, 6)}월` : ''
}

/**
 * 날짜 포맷 변환
 * @param date
 * @param format
 * @returns {string}
 */
export const convertDateForamt = (date, format = "YYYYMMDD") => {
  return date ? dayjs(date).format(format) : null;
}

export const getUUID = () => {
  return uuidv4()
}

export const getUniqueFileName = fileName => {
  return `${getUUID()}.${fileName.split('.').pop()}`
}
// 휴대폰 번호에 하이픈 추가 함수
export const formatPhoneNumber = value => {
  if (!value) return ''
  // 숫자만 남기고 나머지 제거
  const numbers = value.replace(/[^0-9]/g, '')
  // 길이에 따라 하이픈 추가
  if (numbers.length <= 3) return numbers // 011
  if (numbers.length <= 6) return `${numbers.slice(0, 3)}-${numbers.slice(3)}` // 011-123
  if (numbers.length <= 10) return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}` // 011-123-4567
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}` // 010-1234-5678 (최대 11자리)
}
// 사업자번호 하이픈 추가 함수
export const formatBizNumber = value => {
  if (!value) return ''
  // 숫자만 남기고 나머지 제거
  const numbers = value.replace(/[^0-9]/g, '')
  // 길이에 따라 하이픈 추가
  if (numbers.length <= 3) return numbers // 123
  if (numbers.length <= 5) return `${numbers.slice(0, 3)}-${numbers.slice(3)}` // 123-45
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5)}` // 123-45-67890 (최대 10자리)
}
// 일반 전화번호(내선번호 포함) 하이픈 포맷터
export const formatTelNumber = (value) => {
  if (!value) return ''
  // 숫자만 남기기
  const numbers = value.replace(/[^0-9]/g, '')
  const len = numbers.length
  if (len < 3) return numbers

  // 자리수 기준으로 지역번호 길이 결정 (‘02’는 2자리, 나머지는 3자리)
  const areaLen = numbers[0] === '0' && numbers[1] === '2' ? 2 : 3
  const area = numbers.slice(0, areaLen)
  const rest = numbers.slice(areaLen)

  if (rest.length <= 4) {
    // ex) 02-1234, 031-1234
    return `${area}-${rest}`
  }
  if (rest.length <= 8) {
    // ex) 02-123-4567, 031-123-4567
    return `${area}-${rest.slice(0, rest.length - 4)}-${rest.slice(-4)}`
  }
  // ex) 02-1234-5678XX  (extension 같은 추가 자리도 4+4로만 잘라서 표시)
  return `${area}-${rest.slice(0, 4)}-${rest.slice(4, 8)}`
}

/**
 * 모바일 여부 확인
 * @returns {boolean}
 */
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}


